/**
 * Magnetic pull - interactive elements attract the cursor subtly.
 * Elements with `data-magnetic` get a slight transform toward mouse proximity.
 * Uses a single shared document listener for all elements.
 */

export function initMagnetic(root: HTMLElement): () => void {
  if ('ontouchstart' in window) return () => {};

  const elements = root.querySelectorAll<HTMLElement>('[data-magnetic]');
  if (elements.length === 0) return () => {};

  const strength = 0.3;
  const maxDist = 150;

  function onMove(e: MouseEvent) {
    for (const el of elements) {
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < maxDist) {
        const pull = (1 - dist / maxDist) * strength;
        el.style.transform = `translate(${dx * pull}px, ${dy * pull}px)`;
        el.style.transition = 'none';
      } else if (el.style.transform) {
        el.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
        el.style.transform = '';
      }
    }
  }

  document.addEventListener('mousemove', onMove);

  return () => {
    document.removeEventListener('mousemove', onMove);
    for (const el of elements) {
      el.style.transform = '';
      el.style.transition = '';
    }
  };
}
